import { PRESENTLEVELS_EVENT_NAMES } from '@/presentlevels/event_names.ts'
import { SKILL_STATEMENT_EVENT_NAMES } from '@/presentlevels/no-ai/event_names.ts'
import { TEXT_EDITOR_EVENTS } from '@/components/editor/event_names.ts'
import { RESOURCE_EVENTS } from '@/resources/event_names.ts'
import { LIBRARY_EVENT_NAMES } from '@/library/library_event_names.ts'
import { IMPACT_OF_DISABILITY_EVENT_NAMES } from '@/impact-of-disability/event_names.ts'
import { GOAL_INDEX_EVENT_NAMES } from '@/goalindex/event_names.ts'
import { UDL_INDEX_EVENT_NAMES } from '@/strategies/udlindex/event_names.ts'
import { BROWSE_STRATEGIES_EVENT_NAMES, SAVED_STRATEGY_EVENT_NAMES, STRATEGY_DETAIL_EVENT_NAMES, STRATEGY_WIZARD_EVENT_NAMES } from '@/strategies/event_names.ts'
import { CURATED_COLLECTION_EVENT_NAMES } from '@/curated_collections/event_names.ts'
import { BROWSE_GOALS_EVENT_NAMES, GOAL_WIZARD_EVENT_NAMES } from '@/goals/event_names.ts'
import { BROWSE_PRESENT_LEVELS_EVENT_NAMES } from '@/browse/presentlevels/event_names.ts'
import { BROWSE_ASSESSMENTS_EVENT_NAMES } from '@/browse/assessments/event_names.ts'
import { ASSESSMENT_WIZARD_EVENT_NAMES } from '@/assessments/event_names.ts'

export const EVENT_NAMES = {
  PRESENTLEVELS: { ...PRESENTLEVELS_EVENT_NAMES },
  SKILL_STATEMENTS: { ...SKILL_STATEMENT_EVENT_NAMES },
  TEXT_EDITOR: { ...TEXT_EDITOR_EVENTS },
  RESOURCES: { ...RESOURCE_EVENTS },
  APP: {
    MOUNTED: 'App Mounted'
  },
  MISC: {
    COPIED_TEXT: 'Copied Text',
    COPIED_SHARE_LINK: 'Copied Share Link'
  },
  RESEARCH_CITATIONS: {
    CLICKED: 'Clicked Research Citation'
  },
  LIBRARY: { ...LIBRARY_EVENT_NAMES },
  IMPACT_OF_DISABILITY: { ...IMPACT_OF_DISABILITY_EVENT_NAMES },
  GOAL_INDEX: { ...GOAL_INDEX_EVENT_NAMES },
  UDL_INDEX: { ...UDL_INDEX_EVENT_NAMES },
  BROWSE_STRATEGIES: { ...BROWSE_STRATEGIES_EVENT_NAMES },
  STRATEGY_WIZARD: { ...STRATEGY_WIZARD_EVENT_NAMES },
  STRATEGY_DETAIL: { ...STRATEGY_DETAIL_EVENT_NAMES },
  CURATED_COLLECTION: { ...CURATED_COLLECTION_EVENT_NAMES },
  SAVED_STRATEGY: { ...SAVED_STRATEGY_EVENT_NAMES },
  ON_DEMAND_TRAINING: {
    LOGGED_IN: 'Logged Into On Demand Training',
    LOGIN_FAILED: 'On Demand Training Login Failed'
  },
  BROWSE_GOALS: { ...BROWSE_GOALS_EVENT_NAMES },
  GOAL_WIZARD: { ...GOAL_WIZARD_EVENT_NAMES },
  BROWSE_PRESENT_LEVELS: { ...BROWSE_PRESENT_LEVELS_EVENT_NAMES },
  BROWSE_ASSESSMENTS: { ...BROWSE_ASSESSMENTS_EVENT_NAMES },
  ASSESSMENT_WIZARD: { ...ASSESSMENT_WIZARD_EVENT_NAMES },
}